import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M49.5,45.8 L40.8,45.8 L40.8,50.2 L44.2,50.2 C44.2,53.1 42.1,54.8 39.2,54.8 C35.4,54.8 33.1,52.2 33.1,45.6 C33.1,39.0 35.4,36.4 39.2,36.4 C41.8,36.4 43.7,37.8 44.0,40.1 L49.3,39.4 C48.6,34.2 44.8,31.0 39.2,31.0 C32.2,31.0 27.5,35.8 27.5,45.6 C27.5,55.4 32.2,60.2 39.2,60.2 C45.8,60.2 49.5,56.0 49.5,49.8 L49.5,45.8 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
